/* istanbul ignore file */
import { Badge } from 'framework/ui/mui-builder';
import { FieldBadgeProps } from 'framework/ui/ui-builder';

const BenchBadge = (props: FieldBadgeProps) => {
  return (
    <Badge color="primary" sx={{ ml: 1 }} {...props}>
      Bench
    </Badge>
  );
};

export default BenchBadge;
